import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Button } from 'components/kit';
import { SET_AS_BUSY, SET_BRANCH_BUSY, SET_AVAILABILITY, EDIT_AVALIABILITY } from 'constants/translations';
import { Text } from 'components/service';
import EditBranchesAvailability from 'components/common/branch/Busy/EditBranchesAvailability';
import SetAsBusy from 'components/common/branch/Busy/SetAsBusy';

const OrderFrameSetAsBusyButton = ({
  isEditAvailablityButton,
  lang,
  open,
  selectedBranch,
  branches,
  selectedStore,
  close,
  setIsBusy,
}) => {
  const buttonSize = isEditAvailablityButton ? 'close' : 'option';
  const buttonKind = isEditAvailablityButton ? 'borderlessButton' : 'tertiary';
  return (
    <Button
      data-testid={isEditAvailablityButton ? 'edit-avalibility-btn' : 'set-busy-btn'}
      size={buttonSize}
      kind={buttonKind}
      onClick={() =>
        open({
          title: (
            <div className={cx('flex justify-between items-center', lang === 'ar' && 'flex-row-reverse')}>
              <div className="flex flex-col">
                <Text
                  value={!selectedBranch ? SET_AS_BUSY : SET_BRANCH_BUSY}
                  payload={selectedBranch && (lang === 'en' ? selectedBranch.titleEn : selectedBranch.titleAr)}
                />
                <Text className="text-xs text-zyda-grey-500 font-normal" value={SET_AVAILABILITY} />
              </div>
            </div>
          ),
          body: !selectedBranch ? (
            <EditBranchesAvailability
              branches={branches}
              lang={lang}
              timeZone={selectedStore.timeZone}
              open={open}
              close={close}
              setIsBusy={setIsBusy}
            />
          ) : (
            <SetAsBusy
              branchId={selectedBranch.id}
              onCancel={close}
              setIsBusy={setIsBusy}
              busyModeTranslated={selectedBranch.id && selectedBranch.busyMode}
            />
          ),
          size: 'max-w-md',
        })
      }
    >
      <Text
        value={isEditAvailablityButton ? EDIT_AVALIABILITY : SET_AS_BUSY}
        className={cx(isEditAvailablityButton && 'text-primary-base font-normal')}
      />
    </Button>
  );
};

export default OrderFrameSetAsBusyButton;

OrderFrameSetAsBusyButton.propTypes = {
  isEditAvailablityButton: PropTypes.bool.isRequired,
  lang: PropTypes.oneOf(['en', 'ar']).isRequired,
  open: PropTypes.func.isRequired,
  selectedBranch: PropTypes.shape({ titleEn: PropTypes.string, titleAr: PropTypes.string, id: PropTypes.string })
    .isRequired,
  selectedStore: PropTypes.shape({ timeZone: PropTypes.string }).isRequired,
  close: PropTypes.func.isRequired,
  setIsBusy: PropTypes.func.isRequired,
  branches: PropTypes.arrayOf({
    busy: PropTypes.bool,
    busyFrom: PropTypes.string,
    busyMode: PropTypes.string,
    busyUntil: PropTypes.string,
    deliveryOrdersEnabled: PropTypes.bool,
    externalId: PropTypes.string,
    id: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    pickupOrdersEnabled: PropTypes.bool,
    titleAr: PropTypes.string,
    titleEn: PropTypes.string,
  }).isRequired,
};
